export interface DonationCampaign {
  organizationId: number;
  disasterId: number;
  locationID: number;
  givingPortalUrl: string;
  campaignName: string;
}
